import {
    getReportConditionals,
    modelAutocomplete,
} from '../../../../services/apiService';
import {
    InputHandlerContext,
    RepeaterHandlerContext,
    SearchResultOption,
} from '../../../documents/types';
import { formatConditionals } from '../utils/cptDocumentViewUtils';
import {
    appendConditionBlock,
    buildConditionBlock,
    removeConditionBlock,
} from '../utils/cptFormUtils';

export const searchImplants = async (
    query: string
): Promise<SearchResultOption[]> => {
    const results = await modelAutocomplete(query);
    if (!Array.isArray(results)) return [];
    return results.map((result: any) => ({
        ...result,
        label: result?.term || result?.name || result?.label || '',
        value: result?.value || result?._id || result?.term || result?.name,
    }));
};

export const applyImplantConditionals = async ({
    option,
    updateData,
    onContextUpdate,
}: InputHandlerContext) => {
    if (!option || !option._id) return;

    const conditionals = await getReportConditionals(option._id);
    if (!conditionals) return;

    const formatted = formatConditionals(conditionals);
    const updates = {
        _conditionals: formatted,
        _implantId: option._id,
        _implantModel: option.label || option.term || option.name,
        _implantManufacturer:
            conditionals.manufacturer || option.manufacturer,
        _mriStatus: option.mriStatus,
        manufacturer: conditionals.manufacturer || option.manufacturer,
    };

    if (onContextUpdate) {
        onContextUpdate(updates);
    } else {
        updateData('mrConditions', formatted);
    }
};

export const appendImplantConditionBlock = ({
    item,
    itemId,
    data,
    watch,
    updateData,
    setValue,
}: RepeaterHandlerContext) => {
    if (!item._conditionals) return;

    const newConditionBlock = buildConditionBlock(
        itemId,
        item._implantModel,
        item._implantManufacturer,
        item._mriStatus,
        item._conditionals
    );
    const currentConditions = watch('mrConditions') || data.mrConditions || '';
    const newConditions = appendConditionBlock(
        currentConditions,
        newConditionBlock
    );
    updateData('mrConditions', newConditions);
    setValue('mrConditions', newConditions);
};

export const removeImplantConditionBlock = ({
    itemId,
    data,
    watch,
    updateData,
    setValue,
}: RepeaterHandlerContext) => {
    const formConditions = watch('mrConditions') || '';
    const currentConditions = formConditions || data.mrConditions || '';
    const newConditions = removeConditionBlock(currentConditions, itemId);
    updateData('mrConditions', newConditions);
    setValue('mrConditions', newConditions);
};
